<template>

    <section class="hero flex">
        <div class="hero-body flex_block">
            <div class="container has-text-centered  results_cands">

                <h1 class="title is-size-2 results_big_title">{{ $t('modules.candidates.results.title') }}</h1>

                <p class="first_notice" >
                    {{ $t('modules.candidates.results.firstNotice_1', {recruiter_username: recruiterName}) }}<br>
                    <span v-if="show_results">
                        {{ $t('modules.candidates.results.firstNotice_2', {recruiter_username: recruiterName}) }}
                    </span>
                </p>

                <div class="grey_bloc" v-if="show_results">
                    <div class="columns strengths_results_row">
                        <div class="column">
                            <h3 class="survey_title title is-size-3 has-text-left">{{ $t('modules.candidates.results.subtitle2') }}</h3>
                            <p class="has-text-left" v-html="$t('modules.candidates.results.notice', {recruiter_username: recruiterName})"/>
                        </div>
                        <div class="column">

                            <div id="agility_tab" class=" flex_content" v-if="currentEval.saven_test">

                                <div class=" results_strength_scores">

                                    <div class="strength_scores">

                                        <StrengthScore :dimId="currentEval.saven_test.strengths_order[0][0]" :scoreIndex="1" />
                                        <StrengthScore :dimId="currentEval.saven_test.strengths_order[1][0]" :scoreIndex="2" />
                                        <StrengthScore :dimId="currentEval.saven_test.strengths_order[2][0]" :scoreIndex="3" />
                                        <StrengthScore :dimId="currentEval.saven_test.strengths_order[3][0]" :scoreIndex="4" />
                                        <StrengthScore :dimId="currentEval.saven_test.strengths_order[4][0]" :scoreIndex="5" />

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="grey_bloc" v-if="show_results">
                    <h3 class="survey_title title is-size-3 s3_results_picto_row ">
                        <span><img src="@/assets/s3_collegue.png" /></span>
                        {{ $t('modules.candidates.results.work') }}
                    </h3>

                    <div v-for="text in currentEval.saven_test.game_rules_texts['f1']">
                        <p>{{ text }}</p>
                    </div>
                </div>


                <!-- <h3 class="survey_title title_m_t title is-size-3">{{ $t('modules.candidates.results.relation') }}</h3> -->
                <div class="grey_bloc" v-if="show_results">
                    <h3 class="survey_title title is-size-3 s3_results_picto_row">
                        <span><img src="@/assets/s3_travail.png" /></span>
                        {{ $t('modules.candidates.results.friends') }}
                    </h3>

                    <div v-for="text in currentEval.saven_test.game_rules_texts['f2']">
                        <p>{{ text }}</p>
                    </div>
                </div>

                <div v-if="currentEval.vip_passeport_access == '1' && show_results" >
                    <div class="bluebloc">
                        <h3 class="survey_title title is-size-3 blue_bloc_title">
                            {{ $t('modules.candidates.results.notice_passeport', { companyName: currentEval.company_name }) }}
                        </h3>
                    </div>
                </div>

            </div>

        </div>
    </section>

</template>

<script>
import StrengthScore from "@/modules/evaluations/components/scores/strengthScore"

export default {
    name: 'CandidateResults',
    components: {
        StrengthScore
    },
    data(){
        return {}
    },
    computed: {
        currentEval(){
            return this.$store.state.CandidateStore.results
        },
        recruiterName(){
            if (this.currentEval && this.currentEval.recruiter_name){
                return this.currentEval.recruiter_name
            }else{
                return ""
            }
        },
        show_results(){
            return true
        }

    },


}

</script>

<style lang="scss">
.results_strength_scores{
    .strength_scores{
        width: 500px;
        margin: auto;
    }
}
.results_cands{
    margin-top: 50px;

}
.results_cands p{
    font-size: 1.5rem;
    text-align: justify;
}
.strengths_results_row{
    align-items: center;
}
.s3_results_picto_row{
    display: flex;
    align-items: center;
    color: #f9bb5c!important;
    margin-top: 0;
    &.flex_end{
        justify-content: flex-end;
    }
    span{
        padding: 10px;
        img{
            width: 100px;
        }
    }
}
.title_m_t{
    margin-top: 70px;
}
.bluebloc{
    background: $info;
    color: white;
    padding: 30px;
    font-weight: 500;
    text-align: center;
    p{
        text-align: center;
    }
    .blue_bloc_title{
        color: white;
    }
}
.grey_bloc{
    background: $white-ter;
    padding: 30px;
    margin-bottom: 50px;
}
.results_big_title{
    margin: 50px 0!important;
}
.first_notice{
    text-align: center!important;
}

</style>